// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import Queue from "nq";
import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { Button, dialog } from "nq-component";

class UsersFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;
    this.view.setObject(this.object);
  }

  fields = ["region", "office", "division", "section", "unit", "cluster"];

  getLastNonEmptyField = (source) => {
    let result = "";
    let index = -1;

    this.fields.forEach((field, i) => {
      if (source[field] && source[field] !== "") {
        result = source[field];
        index = i;
      }
    });

    return { result, index };
  };

  async save() {
    const { object } = this.view.state;
    // object.email = object.username;
    const collection = this.view.getCollectionName();
    const biometricId = String(object?.employee?.biometricId) || null;
    const now = new Date();
    const dateToday = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
    ).toISOString();

    if (!object?.employee) {
      return;
    }

    this.view.setState({ progress: true });
    try {
      const [usernameExists, empExists, sessions, biometric_devices] =
        await Promise.all([
          findObjectUseCase().execute("users", {
            where: { username: object.username },
            keys: ["account"],
          }),
          findObjectUseCase().execute("users", {
            where: { "employee.id": object.employee.id },
            keys: ["id"],
          }),
          findObjectUseCase().execute("sessions", {
            where: { "user.id": object.id, created: { $gte: dateToday } },
          }),
          findObjectUseCase().execute("biometric_devices", {
            where: {
              $or: [
                { region: { $eq: object.employee.region } },
                { office: { $eq: object.employee.office } },
                { division: { $eq: object.employee.division } },
                { section: { $eq: object.employee.section } },
                { unit: { $eq: object.employee.unit } },
                { cluster: { $eq: object.employee.cluster } },
              ],
            },
            keys: ["id"],
          }),
        ]);

      if (empExists.length > 0 && object.id === undefined) {
        this.view.showError("Employee already exist!");
        return;
      }

      // jobportal account linking
      if (
        usernameExists.length > 0 &&
        usernameExists[0].account === "jobPortal"
      ) {
        const mergeObj = { ...usernameExists[0], ...object };
        mergeObj.employee = { id: mergeObj.employee.id };
        mergeObj.account = "linking";
        this.view.setState({ progress: false });
        this.MergingPortalAccount(mergeObj, collection);
        return;
      }

      if (usernameExists.length > 0 && object.id === undefined) {
        this.showError("Username Already exists");
        return;
      }

      try {
        object.roles = object.roles.map((role) => {
          return { id: role.id, name: role.id };
        });
        await this.insertBioCommand(object, biometricId, biometric_devices);
        await upsertUseCase().execute(collection, object);
        this.showSuccess("User Successfully Created");

        if (sessions.length > 0 && object.id !== undefined) {
          for (const session of sessions) {
            try {
              await new Queue.Document().delete("sessions", session.id);
            } catch (e) {
              console.error(e.message || e);
            }
          }
        }
      } catch (error) {
        this.showError(error);
      }
    } finally {
      this.view.setState({ progress: false });
    }
  }

  async insertBioCommand(object, biometricId, biometric_devices) {
    if (biometric_devices.length === 0) {
      return;
    }

    const name = [
      object?.employee?.Firstname,
      object?.employee?.Middlename,
      object?.employee?.surname,
    ]
      .filter(Boolean)
      .join(" ");

    const pri =
      object.username === "masteradmin@bi.com" || object.username === "1"
        ? "14"
        : "0";

    // Insert user command for each device
    for (const device of biometric_devices) {
      const insertUser = {
        type: "DATA USER",
        device: { id: device.id },
        parameters: {
          PIN: biometricId,
          Name: name,
          Passwd: object?.bioPass || biometricId,
          Pri: pri,
        },
      };
      console.log("insertUser; ", insertUser);

      try {
        await upsertUseCase().execute("biometric_commands", insertUser);
      } catch (e) {
        console.error(`command user for device ${device.id}: `, e.message || e);
        throw Error(e.message || e);
      }
    }

    // Insert fingerprint commands for each device
    // if (biometric_prints.length > 0) {
    //   for (const device of biometric_devices) {
    //     for (const finger of biometric_prints) {
    //       const { pin, fid, size, valid, tmp } = finger;
    //       const command = {
    //         type: "DATA UPDATE FINGERTMP",
    //         device: { id: device.id },
    //         parameters: {
    //           PIN: pin,
    //           FID: fid,
    //           Size: size,
    //           Valid: valid,
    //           tmp: tmp,
    //         },
    //       };
    //       try {
    //         await upsertUseCase().execute("biometric_commands", command);
    //       } catch (e) {
    //         console.error(
    //           `command finger for device ${device.id}: `,
    //           e.message || e,
    //         );
    //         throw Error(e.message || e);
    //       }
    //     }
    //   }
    // }
  }

  MergingPortalAccount(mergeObj, collection) {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4 className="text-danger">⚠️ Account Already Exists</h4>
            <hr />
            <p style={{ fontSize: "15px", padding: "1rem" }}>
              We found an existing account with the same email/username{" "}
              {mergeObj.username} in the Job Portal system. This means the
              person may already have a Job Portal account. Would you like to
              link this existing account to the employee record in HRIS, or
              create a new HRIS account with a different username?
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.ConfirmAccountLinking(mergeObj, collection)}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  async ConfirmAccountLinking(mergeObj, collection) {
    if (this._linkingAccount) return;
    this._linkingAccount = true;
    this.view.setState({ progress: true });
    try {
      dialog.close();
      this.view.showProgressDialog();
      mergeObj.roles = (mergeObj.roles || []).map((role) => {
        return { id: role.id, name: role.id };
      });
      await upsertUseCase().execute(collection, mergeObj);
      this.view.hideProgressDialog();
      this.showSuccess("User successfully linked");
    } catch (error) {
      this.view.hideProgressDialog();
      this.showError(error);
    } finally {
      this._linkingAccount = false;
      this.view.setState({ progress: false });
    }
  }
}

export default UsersFormPresenter;
